import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="w-full px-6 py-20 md:py-28 bg-white/50" data-id="element-113">
      <div className="max-w-2xl mx-auto" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-115">
          <h2 className="font-serif text-3xl md:text-4xl text-stone-800 mb-10 text-center" data-id="element-116">
            What is actually happening
          </h2>

          <div className="space-y-8 text-lg text-stone-600 leading-relaxed" data-id="element-117">
            <p data-id="element-118">Here is the honest truth.</p>

            <p data-id="element-119">
              Most mainstream advice is designed for a stable system. It assumes
              you can restrict a little, move a little more, and your body will
              cooperate.
            </p>

            <p data-id="element-120">
              But when sleep is off, when stress is high, and when hormones are
              shifting, you can do the same old actions and get a completely
              different outcome.
            </p>

            <p data-id="element-121">
              More cardio can increase hunger and make you feel puffy. More
              restriction can make you obsess, then rebound, then blame
              yourself.
            </p>

            <p className="text-xl md:text-2xl font-serif text-terracotta italic text-center py-4" data-id="element-122">
              You do not need more intensity. You need the right sequence.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}